<template>
  <b-container fluid >
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4 class="">
               <i class="fa ri-question-answer-fill" aria-hidden="true" style="font-size: 24px; margin-right: 3px; color: var(--iq-primary);"></i>
              {{cvCardTitle}}&nbsp;&nbsp;<i class="fa-solid fa-circle-info" title="Shows Latest Attempts Only"></i>
            </h4>
            <h5>Name:&nbsp;<span>{{appResData && appResData[0] && appResData[0].app_name ? appResData[0].app_name : ""}}</span></h5>
            <h6><small>Id:&nbsp;<span>{{appResData && appResData[0] && appResData[0].app_id ? appResData[0].app_id : ""}}</span>&nbsp;&nbsp;
              <b-btn class="btn button" variant="transparent" @click="openApp(appResData[0])"><i class="fa fa-eye mb-1 text-gideColor pointer" aria-hidden="true" title="View App"></i> </b-btn>
              <AppResultSyncModal :propAppData="appResData[0]"/>
            </small></h6>
            <h6><small>App Type:&nbsp;<span>{{appResData && appResData[0] && appResData[0].app_type ? appResData[0].app_type : ""}}</span></small></h6>
            <h6><small>Category:&nbsp;<span>{{appResData && appResData[0] && appResData[0].app_category ? appResData[0].app_category : ""}}</span></small></h6>
            <h5>Total Participants:&nbsp;<span>{{ totalRows }}</span></h5>
          </div>
        </div>
        <div class="iq-card p-3">
          <div style="gap: 10px;" class="row flex-wrap flex-md-nowrap mb-2 col-12">
            <!-- Search by User Name/Email -->
            <b-col style="gap: 8px;" class="d-flex align-items-center col-12 col-md-4">
              <input
                class="form-control"
                id="search"
                v-model="whereFilter.search_param"
                type="search"
                :placeholder="cvSearchText"
                @input="onSearchParamChange"
              />
              <b-button v-if="whereFilter.search_param && whereFilter.search_param.length > 3" class="px-3 py-2" variant="primary" @click="searchUserWithParams">Search</b-button>
              <b-button v-else-if="whereFilter.search_param && whereFilter.search_param.length <= 3" class="px-3 py-2" variant="secondary" disabled title="Enter at least 4 characters">Search</b-button>
              <b-button v-if="whereFilter.search_param" class="px-3 py-2" variant="outline-danger" @click="resetSearchParams">Reset</b-button>
            </b-col><!-- Search by User Name/Email -->

            <!-- Search by Attempt -->
            <b-col class="col-12 col-md-4">
              <multiselect
                v-model="selectedAttempt.attempts"
                :options="attemptsOptionsList"
                placeholder="Select Attempt"
                track-by="attempts"
                label="attempts"
                @select="attemptSelected">
              </multiselect>
            </b-col><!-- Search by Attempt -->

            <!-- Date Range Picker -->
            <b-col class="date_csv w-100 col-md-4 p-0">
              <div style="gap: 8px;" class="dateRange d-flex align-items-center w-100">
                <date-range-picker class="w-100" ref="picker" :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"  v-model="whereFilter.dateRange"  @update="getAppResultDateWise()" ></date-range-picker>
                <!-- Backend csv download -->
                <i v-if="appResData && appResData[0] && appResData[0].app_name && appResData[0].app_name.includes('SAT')" variant="primary" class="fa fa-download Download_button" @click="backendCsvDownloadSAT"></i>
                <i v-else class="fa-solid fa-file-csv Download_button" title="download Csv" @click="backendCsvDownload"></i>
                <!-- Backend csv download -->
              </div>
            </b-col><!-- Date Range Picker -->
          </div>
        </div>
        <div class="iq-card row p-3">
          <b-col class="container_minheight" md="12" v-if="appResultObjList && appResultObjList.length > 0"  :key="currentBatchNo">
            <b-table
              hover
              responsive
              :items="appResultObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentBatchNo"
              :per-page="dataPerPage"
            >
              <template v-slot:cell(user_name)="data">
                <div>
                  <span>{{ data.item.user_name }}</span><br>
                  <span><small>Id: {{ data.item.user_id }}</small></span><br>
                  <span><small>(Email): {{ data.item.user_email }}</small></span><br>
                </div>
                <!-- <button class="actionIcon btn mt-1 primary-color" title="View Assessment Result" @click="goToResultsPage(data.item.user_id, data.item)"><i class="fa-solid fa-file-text font-size-20"></i></button> -->
                <button class="actionIcon btn mt-1 primary-color" title="View Attempts" @click="goToAttemptList(data.item.user_id, data.item.app_id)"><i class="fa-solid fa-square-poll-vertical font-size-20"></i></button>
                <!-- <button class="actionIcon btn mt-1 primary-color" title="Analyse Assessment" @click="analyzeResultsV1(data.item)"><i class="fa-solid fa-magnifying-glass-chart font-size-20"></i></button> -->
                <!-- <button class="actionIcon btn mt-1 primary-color" title="Assessment Detailed Explanation" @click="analyzeResults(data.item)"><i class="fa-solid fa-align-justify font-size-20"></i></button> -->
                <button class="actionIcon btn mt-1 primary-color" title="Fix Duplicate Results" @click="fixDuplicateResults(data.item)"><i class="fa-solid fa-bug font-size-20"></i></button><br>
                <small v-if="userData?.user_role == 'USERROLE11111' || userData?.user_role == 'USERROLE11118'" style="font-size: 10px;">
                  AppId: {{data.item.app_id}}<br>
                  TestId: {{data.item.aprs_id}}<br>
                </small>
              </template>
              <template v-slot:cell(aprs_score)="data">
                <span>{{ data.item.aprs_score ? data.item.aprs_score : "0" }} / {{data.item.aprs_total_score}}</span>
              </template>
              <template v-slot:cell(aprs_percentage)="data">
                <!-- <span> {{data.item.aprs_percentage}}%</span> -->
                <span v-if="data.item.qbk_total_question > 0">{{ parseFloat(data.item.correct_answer / data.item.qbk_total_question  * 100).toFixed(2)}}%</span>
                <span v-else>N/a</span>
              </template>
              <!-- <template v-slot:cell(org_name)="data">
                <span>{{ data.item.org_name }} {{ data.item.org_city ? "," + data.item.org_city : data.item.org_city }}</span><br>
              </template> -->
              <template v-slot:cell(created_on)="data">
                <span>{{ data.item.created_on | dateFormatDDMMMYYYYHHMMA }}</span>
              </template>
            </b-table>
          </b-col>
          <b-col class="container_minheight" md="12" v-else>
            No data found
          </b-col>
        </div>
        <b-row>
          <b-col sm="7" md="8" class="my-1">
              <b-btn class="mb-2" variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn && totalRows > (dataPerPage * currentBatchNo)">Load More</b-btn>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import { AppResults } from "../../../FackApi/api/appResults.js"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit.js"
import userPermission from "../../../Utils/user_permission"
import Multiselect from "vue-multiselect"
import AppResultSyncModal from "../Apps/AppResultSyncModal.vue"

export default {
  name: "AppResultList",
  data () {
    return {
      apiName: "apps_results_console_list",
      cvCardTitle: "App Results - Quiz, Competition",
      cvSearchText: "Type to Search",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "App Result List Response",
      showModelAppResultAdd: false,
      showModelAppResultEdit: false,
      showModelAppResultDelete: false,
      sortBy: "name",
      sortDesc: false,
      VUE_APP_ENV: process.env.VUE_APP_ENV,
      columns: [
        { label: "# ", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "User Details", key: "user_name", class: "text-left", sortable: true },
        { label: "Attempt Count", key: "attempt", class: "text-left align-text-top", sortable: true },
        // { label: "Total Questions", key: "qbk_total_question", class: "text-left align-text-top", sortable: true },
        // { label: "Correct Answers", key: "correct_answer", class: "text-left align-text-top", sortable: true },
        // { label: "Wrong Answers", key: "wrong_answer", class: "text-left align-text-top", sortable: true },
        // { label: "Skipped Questions", key: "skipped_answer", class: "text-left align-text-top", sortable: true },
        // { label: "Score", key: "aprs_score", class: "text-left align-text-top", sortable: true },
        // { label: "Percentage", key: "aprs_percentage", class: "text-left align-text-top", sortable: true },
        { label: "Quiz Date", key: "created_on", class: "text-left align-text-top w-200px", sortable: true }
      ],
      appResultObjList: null,
      appResultEditObj: null,
      filter: null,
      filterOn: [],
      totalRows: 0,
      currentBatchNo: 1,
      dataPerPage: 100,
      appResData: [],
      showLoadMoreBtn: false,
      downloadCsv: false,
      whereFilter: {
        dateRange: {
          startDate: new Date(new Date().setDate(new Date().getDate() - 365)), // From Last Year
          endDate: new Date(new Date().setDate(new Date().getDate() + 1))
        },
        search_param: "",
        attempts: ""
      },
      attemptsOptionsList: [{ attempts: "All" }],
      selectedAttempt: { attempts: null }
    }
  },
  components: {
    Multiselect,
    AppResultSyncModal
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    dateFilter () {
      return { ...this.$store.getters["DateFilter/selectedDateState"] }
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()
    await this.getDateFilter()
    if (this.$route.params.app_id) {
      this.app_id = this.$route.params.app_id
    }

    if (this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11118") {
      this.appResultList()
    }
    else {
      this.$router.go(-1)
    }
  },
  methods: {
    /**
     * Calling Function as per whereFilter
     */
    async getAppResultDateWise () {
      this.appResultList()
      await this.setDateFilter()
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.appResultList(true)
    },
    /**
     * openApp
     */
    openApp (app) {
      this.$router.push(`/quiz_detail/${app.app_id}`)
    },
    /**
     * sync Result
     */
    async syncResult (examItem) {
      const resultSyncResp = await AppResults.appResultSync(this, examItem.app_id)
      if (!resultSyncResp.resp_status) {
        ApiResponse.responseMessageDisplay(this, resultSyncResp)
      }
    },
    /**
     * go To Results Page
     */
    goToResultsPage (userId, item) {
      if (item.app_name.toLowerCase().includes("mock") || item.app_category.toLowerCase().includes("mock") || item.app_name.toLowerCase().includes("-a-thon") || item.app_name.toLowerCase().includes("diagnostic")) {
        window.open(`/app_result_view_v1/${this.app_id}/${userId}/${item.aprs_id}/${item.attempt}`, "_blank") // 0: dont Show, 1: Show:: info message on top of the result page
      }
      else {
        window.open(`/app_result_view/${this.app_id}/${userId}/0`, "_blank") // 0: dont Show, 1: Show:: info message on top of the result page
      }
    },
    /**
     * analyze Results
     */
    analyzeResults (item) {
      this.userId = item.user_id
      window.open(`/app_result_analyse/${item.app_id}/${item.user_id}/${item.aprs_id}?attempt=NA`)
    },
    /**
     * analyzeResultsV1
     */
    analyzeResultsV1 (item) {
      window.open(`/app_result_analyse_v1/${item.app_id}/${item.user_id}/${item.aprs_id}?attempt=NA`)
    },
    /**
     * backendCsvDownload
     */
    async backendCsvDownload () {
      this.whereFilter.downloadCsv = true
      this.whereFilter.downloadSatCsv = false
      this.appResultList(false, true)
    },
    /**
     * backendCsvDownloadSAT
     */
    async backendCsvDownloadSAT () {
      this.whereFilter.downloadCsv = false
      this.whereFilter.downloadSatCsv = true
      this.appResultList(false, true)
    },
    /**
     * Get daterange from LS. If found then use this as default else use the onse set in the data section of the object
     */
    async getDateFilter () {
      let storeDate = await this.dateFilter
      if (storeDate && storeDate.dateRange) {
        this.whereFilter = storeDate
      }
    },
    /**
     * Setting Date Range in the LS
     */
    async setDateFilter () {
      let endDate = this.whereFilter.dateRange.endDate
      this.whereFilter.dateRange.endDate = new Date(new Date(endDate).setDate(new Date(endDate).getDate() + 1))
      let whereDateFilter = { dateRange: this.whereFilter.dateRange }
      await this.$store.commit("DateFilter/addSelectedDate", whereDateFilter)
    },
    /**
     * appResultList
     */
    async appResultList (loadViaLoadMore = false) {
      try {
        let payload = {
          app_id: this.$route.params.app_id,
          user_id: this.userId
        }
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.fetchDistinctAttemptsList = true
        let appResultListResp = await AppResults.appResultConsoleList(this, payload, this.whereFilter)
        if (appResultListResp.resp_status) {
          if (this.whereFilter.downloadCsv) {
            this.whereFilter.downloadCsv = false
            window.open(appResultListResp.resp_csv_file_url)
            return
          }

          if (this.whereFilter.downloadSatCsv) {
            this.whereFilter.downloadSatCsv = false
            window.open(appResultListResp.resp_csv_file_url)
            return
          }

          // Update appResData only on initial load (for app header info)
          if (!loadViaLoadMore && (!this.whereFilter.search_param || this.whereFilter.search_param?.length === 0) && (!this.whereFilter.attempts || this.whereFilter.attempts?.length === 0)) {
            // Initial load → Set appResData with first item for header
            this.appResData = appResultListResp.resp_data.data
          }

          // Update appResultObjList based on load type
          const hasSearchOrFilter = this.whereFilter.search_param?.length > 0 || this.whereFilter.attempts?.length > 0

          if (hasSearchOrFilter || !loadViaLoadMore) {
            // Search/Filter or initial load → Replace table data
            this.appResultObjList = appResultListResp.resp_data.data
          }
          else if (loadViaLoadMore) {
            // Load more → Append table data
            this.appResultObjList = [ ...this.appResultObjList, ...appResultListResp.resp_data.data ]
          }

          this.showLoadMoreBtn = true
          this.appResultObjList.forEach((s, index) => { s.id = index + 1 })

          this.totalRows = appResultListResp.resp_participant_count

          if (appResultListResp.resp_distinct_attempts_options && appResultListResp.resp_distinct_attempts_options.length > 0) {
            this.attemptsOptionsList = [
              { attempts: "All" },
              ...appResultListResp.resp_distinct_attempts_options.map(val => ({
                attempts: val.attempt
              }))
            ]
          }
        }
        else {
          this.currentBatchNo = this.currentBatchNo == 1 ? 1 : (this.currentBatchNo - 1)
          this.showLoadMoreBtn = false
          this.toastMsg = appResultListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
          this.appResultObjList = null
        }

        this.whereFilter.downloadCsv = false
        this.whereFilter.downloadSatCsv = false
      }
      catch (err) {
        console.log("Exception occurred at appResultList() and Exception:", err.message)
      }
    },
    /**
     * fix Duplicate Results
     */
    fixDuplicateResults (item) {
      window.open(`/appResult_list_fix/${item.app_id}/${item.user_id}`)
    },
    /**
     * goTo Quiz/App Attempt List
     */
    goToAttemptList (gideUserId = null, appId) {
      if (!gideUserId) {
        gideUserId = this.userData.user_id
      }

      if (appId) {
        window.open(`/attempt_list/${appId}/${appId}?gide_user_id=${gideUserId}`, "_blank")
      }
    },
    /**
     * onSearchParamChange
     */
    onSearchParamChange () {
      this.whereFilter.search_param = this.whereFilter.search_param.trim()
    },
    /**
     * searchUserWithParams
     */
    async searchUserWithParams () {
      if (this.whereFilter.search_param.length <= 3) {
        this.toastMsg = "Please enter at least 4 characters to search"
        this.toastVariant = "warning"
        this.toastTitle = "Invalid Input"
        this.showToast = true
        return
      }

      this.currentBatchNo = 1
      await this.appResultList()
    },
    /**
     * resetSearchParams
     */
    resetSearchParams () {
      this.whereFilter.search_param = ""
      this.currentBatchNo = 1
      this.appResultList()
      this.toastMsg = "Search cleared"
      this.toastTitle = "Search Reset"
      this.showToast = true
    },
    /**
     * attemptSelected
     */
    attemptSelected (option) {
      if (option.attempts === "All") {
        this.whereFilter.attempts = null
      }
      else {
        this.whereFilter.attempts = option.attempts
      }

      this.currentBatchNo = 1
      this.appResultList()
    }
  }
}
</script>
<style>
  .card-title{
    display: block !important
  }
</style>
